import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StopIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import {
  ContentStyled as Content,
  TitleStyled as Title,
  BodyStyled as Body,
  ButtonStyled as Button,
} from './styles/PanelContentStyled';
import { GoogleTagManager } from '../../../../../helpers';

const Unavailable = ({ close }) => {
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda/problemas-red/modal-reinicio-red/no-disponible',
      pageName: 'Problemas de Red - Reinicio de red - No Disponible',
    });
  }, []);

  return (
    <Content>
      <StopIcon />
      <Body>
        <Title>Ya solicitaste tu reinicio de señal</Title>
        Puedes realizar esta solicitud una vez cada 24 horas. Recomendamos
        reiniciar tu equipo o activar y desactivar el modo avión.
      </Body>
      <Button onClick={close}>Aceptar</Button>
    </Content>
  );
};

Unavailable.propTypes = {
  close: PropTypes.func.isRequired,
};

export default Unavailable;
